import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "m11.784 3.87267c.0961-.16633.3359-.16632.432-.00001l9.2503 16.00414c.0963.1667-.0238.3753-.216.3753h-18.50057c-.19227 0-.31233-.2086-.216-.3753zm1.728-.75156c-.6729-1.16425-2.3511-1.16424-3.024 0l-9.25027 16.00409c-.674327 1.1667.16614 2.6269 1.512 2.6269h18.50057c1.3458 0 2.1863-1.4602 1.512-2.6269zm-.762 6.12681c0-.41421-.3358-.75-.75-.75s-.75.33579-.75.75v3.99998c0 .4142.3358.75.75.75s.75-.3358.75-.75zm-.75 7.24998c-.4142 0-.75.3358-.75.75s.3358.75.75.75h.01c.4142 0 .75-.3358.75-.75s-.3358-.75-.75-.75z",
      fill: "currentColor",
      "fill-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }